// Here should be CommonJS component exports.

module.exports = {
  FileNavigator: require('./components/FileNavigator').default,
  HeaderCell: require('./components/HeaderCell').default,
  LoadingCell: require('./components/LoadingCell').default,
  NameCell: require('./components/NameCell').default,
  MoveToDialog: require('./components/MoveToDialog').default,
  SendDialog: require('./components/SendDialog').default,
  PreviewFileDialog: require('./components/PreviewFileDialog').default,
  CreateFolderDialog: require('./components/CreateFolderDialog').default,
  notifUtils: require('./components/Notifications/utils').default,
  EditDialog: require('./components/EditDialog').default,
  RenameDialog: require('./components/RenameDialog').default,
  SelectOneDriveRootFolderDialog: require('./components/SelectOneDriveRootFolderDialog').default,
  SelectGoogleDriveRootFolderDialog: require('./components/SelectGoogleDriveRootFolderDialog').default,
};
